import React from 'react';
import { EServiceType, TIntakeFormConfig } from 'types/common';
import { getIntakeFormConfig } from 'api/provider';
import { getOpsIntakeFormConfig } from 'api/operation';

const useIntakeFormConfig = (
    specialty: string,
    serviceType: EServiceType,
    isOps?: boolean,
): [TIntakeFormConfig[] | undefined, boolean, (specialty: string, serviceType: EServiceType) => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TIntakeFormConfig[]>();
    const fetchData = async (_specialty: string, _serviceType: EServiceType) => {
        if (!_serviceType || !_specialty) return;
        try {
            setLoading(true);
            const fn = isOps ? getOpsIntakeFormConfig : getIntakeFormConfig;
            const result = await fn(_specialty, _serviceType);
            if (!result.error) {
                const resData = result?.data?.data || [];
                setItems(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        fetchData(specialty, serviceType);
    }, [specialty, serviceType, isOps]);

    return [items, loading, fetchData];
};

export default useIntakeFormConfig;
